import {call, put, takeLatest, delay} from 'redux-saga/effects'
import {actions} from './action'
import {actionTypes} from './constants'
import {ResponseModel} from 'src/cms/helpers/Models/ResponseModel'
import {service} from './service'
import {ActionModel} from 'src/cms/helpers/Models/ActionModel'
import {globalActionTypes} from 'src/app/modules/errors/redux/constants'
import {GrievanceNatureModel} from '../Model/GrievanceNatureModel'
import {ParamsModel} from 'src/app/modules/common/Model'

function* getGrievanceNatureSaga(action: ActionModel) {
  try {
    const params: ParamsModel = action.payload
    yield delay(500)
    const response: ResponseModel = yield call(service.getGrievanceNature, params)
    yield put(actions.getGrievanceNatureSuccess(response?.data?.data))
    yield put(actions.getGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getGrievanceNatureFinish())
  }
}

function* getAllGrievanceNatureSaga() {
  try {
    const response: ResponseModel = yield call(service.getAllGrievanceNature)
    yield put(actions.getAllGrievanceNatureSuccess(response?.data?.data))
    yield put(actions.getAllGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.getAllGrievanceNatureFinish())
  }
}

function* addGrievanceNatureSaga(action: ActionModel) {
  try {
    const body = action.payload
    const response: ResponseModel = yield call(service.addGrievanceNature, body)
    yield put(actions.addGrievanceNatureSuccess(response.data?.data))
    yield delay(100)
    yield put(actions.addGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.addGrievanceNatureFinish())
  }
}

function* enableGrievanceNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.enableGrievanceNature, selectedUsers)
    yield put(actions.enableGrievanceNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.enableGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.enableGrievanceNatureFinish())
  }
}

function* disableGrievanceNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.disableGrievanceNature, selectedUsers)
    yield put(actions.disableGrievanceNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.disableGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.disableGrievanceNatureFinish())
  }
}

function* singleEnableGrievanceNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleEnableGrievanceNature, selectedUsers)
    yield put(actions.singleEnableGrievanceNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleEnableGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleEnableGrievanceNatureFinish())
  }
}

function* singleDisableGrievanceNatureSaga(action: ActionModel) {
  try {
    const selectedUsers: any = action.payload?.data
    const response: ResponseModel = yield call(service.singleDisableGrievanceNature, selectedUsers)
    yield put(actions.singleDisableGrievanceNatureSuccess(response?.data))
    yield delay(100)
    yield put(actions.singleDisableGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.singleDisableGrievanceNatureFinish())
  }
}

function* updateGrievanceNatureSaga(action: ActionModel) {
  try {
    const body: GrievanceNatureModel = action.payload
    const response: ResponseModel = yield call(
      service.updateGrievanceNature,
      body,
      (action as any).id
    )
    yield put(actions.updateGrievanceNatureSuccess(response.data?.data))
    yield put(actions.updateGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.updateGrievanceNatureFinish())
  }
}

function* deleteGrievanceNatureSaga(action: ActionModel) {
  try {
    const body: any = action.payload
    const response: ResponseModel = yield call(service.deleteGrievanceNature, body)
    yield put(actions.deleteGrievanceNatureSuccess(response.data?.data))
    yield delay(0.1)
    yield put(actions.deleteGrievanceNatureFinish())
  } catch (err: any) {
    if (err.response) {
      yield put({type: globalActionTypes.GLOBAL_ERROR, payload: err.response.data.message})
    }
    yield put(actions.deleteGrievanceNatureFinish())
  }
}

export function* saga() {
  yield takeLatest(actionTypes.GET_GRIEVANCE_NATURE_START, getGrievanceNatureSaga)
  yield takeLatest(actionTypes.GET_ALL_GRIEVANCE_NATURE_START, getAllGrievanceNatureSaga)
  yield takeLatest(actionTypes.ADD_GRIEVANCE_NATURE_START, addGrievanceNatureSaga)
  yield takeLatest(actionTypes.UPDATE_GRIEVANCE_NATURE_START, updateGrievanceNatureSaga)
  yield takeLatest(actionTypes.DELETE_GRIEVANCE_NATURE_START, deleteGrievanceNatureSaga)
  yield takeLatest(actionTypes.ENABLE_GRIEVANCE_NATURE_REQUEST, enableGrievanceNatureSaga)
  yield takeLatest(actionTypes.DISABLE_GRIEVANCE_NATURE_REQUEST, disableGrievanceNatureSaga)
  yield takeLatest(
    actionTypes.SINGLE_ENABLE_GRIEVANCE_NATURE_REQUEST,
    singleEnableGrievanceNatureSaga
  )
  yield takeLatest(
    actionTypes.SINGLE_DISABLE_GRIEVANCE_NATURE_REQUEST,
    singleDisableGrievanceNatureSaga
  )
}

